<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
      <div class="input-wrapper">
          <div class="side-wrapper edit-form-title-wrapper">
              <div class="user-icon"></div>
              <p class="input-form-title">{{'USERSEARCHSETTING.FORM_TITLE' | translate}}</p>
          </div>
  
          <div class="menu-input-wrapper">
              <div class="tab-menu">
                  <div class="tab basic-info" (click)="setActiveTab('basic-info')" [ngClass]="{'active': activetab=='basic-info'}">
                      <p>{{'HOME.ROLES_BASICINFO_TABTITLE' | translate}}</p>
                  </div>
                  <div class="tab basic-info" (click)="setActiveTab('properties')" [ngClass]="{'active': activetab=='properties'}">
                    <p>{{'USERSEARCHSETTING.PROPERTIES' | translate}}</p>
                </div>                  
              </div>
              <!--
              -->
              <div class="input-content">
                  <div class="basic-info" *ngIf="activetab == 'basic-info'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                            <div class="input-control">
                                <div class="title"><label for="ViewName">{{'USERSEARCHSETTING.VIEW_NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="ViewName" [(ngModel)]="model.ViewName" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="ModelName">{{'USERSEARCHSETTING.MODEL_NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="ModelName" [(ngModel)]="model.ModelName" />
                            </div>   
                            <div class="input-control">
                                <div class="title"><label for="LayoutName">{{'USERSEARCHSETTING.LAYOUT_NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="LayoutName" [(ngModel)]="model.LayoutName" />
                            </div> 
                            <div class="input-control">
                                <div class="title"><label for="EnableFacets">{{'USERSEARCHSETTING.ENABLE_FACETS' | translate}}</label></div>
                                <input type="checkbox" name="EnableFacets" [(ngModel)]="model.EnableFacets" />
                            </div>                                                                                  
                            <div class="input-control">
                                <div class="title"><label for="FilterQuery">{{'USERSEARCHSETTING.FILTER_QUERY' | translate}}</label></div>
                                <textarea class="form-control" rows="10" type="text" name="FilterQuery" [(ngModel)]="model.FilterQuery"></textarea>
                            </div> 
                            <div class="input-control">
                                <div class="title"><label for="QuickViewEnabled">{{'USERSEARCHSETTING.QUICK_VIEW_ENABLED' | translate}}</label></div>
                                <input type="checkbox" name="QuickViewEnabled" [(ngModel)]="model.QuickViewEnabled" />
                            </div>                             
                            <div class="input-control">
                                <div class="title"><label for="QuickViewFormName">{{'USERSEARCHSETTING.QUICK_VIEW_FORM_NAME' | translate}}</label></div>
                                <input class="form-control" type="text" name="QuickViewFormName" [(ngModel)]="model.QuickViewFormName" />
                            </div>       
                            <div class="input-control">
                                <div class="title"><label for="OnlyLastNodeNames">{{'USERSEARCHSETTING.ONLY_LAST_NODE_NAMES' | translate}}</label></div>
                                <input type="checkbox" name="OnlyLastNodeNames" [(ngModel)]="model.OnlyLastNodeNames" />
                            </div>                     
                            <div class="input-control">
                                <div class="title"><label for="ShowActionsColumn">{{'USERSEARCHSETTING.SHOW_ACTIONS_COLUMN' | translate}}</label></div>
                                <input type="checkbox" name="ShowActionsColumn" [(ngModel)]="model.ShowActionsColumn" />
                            </div>                     
                            <div class="input-control">
                                <div class="title"><label for="ShowItemNumber">{{'USERSEARCHSETTING.SHOW_ITEM_NUMBER' | translate}}</label></div>
                                <input type="checkbox" name="ShowItemNumber" [(ngModel)]="model.ShowItemNumber" />
                            </div>                                                                                
                            <div class="input-control">
                                <div class="title"><label for="SearchPlaceholderTitle">{{'USERSEARCHSETTING.SEARCH_PLACEHOLDER_TITLE' | translate}}</label></div>
                                <input class="form-control" type="text" name="SearchPlaceholderTitle" [(ngModel)]="model.SearchPlaceholderTitle" />
                            </div>  
                            <div class="input-control">
                                <div class="title"><label for="DefaultSorter">{{'USERSEARCHSETTING.DEFULAT_SORTER' | translate}}</label></div>
                                <textarea class="form-control" rows="10" type="text" name="DefaultSorter" [(ngModel)]="model.DefaultSorter"></textarea>
                            </div>                             
                            <div class="input-control">
                                <div class="title"><label for="CustomFacets">{{'USERSEARCHSETTING.CUSTOM_FACETS' | translate}}</label></div>
                                <input class="form-control" type="text" name="CustomFacets" [(ngModel)]="model.CustomFacets" />
                            </div>  
                            <div class="input-control">
                                <div class="title"><label for="CustomPageSize">{{'USERSEARCHSETTING.CUSTOM_PAGE_SIZE' | translate}}</label></div>
                                <input class="form-control" type="number" name="CustomPageSize" [(ngModel)]="model.CustomPageSize" />
                            </div>     
                            <div class="input-control">
                                <div class="title"><label for="FacetsOrder">{{'USERSEARCHSETTING.FACETS_ORDER' | translate}}</label></div>
                                <input class="form-control" type="text" name="FacetsOrder" [(ngModel)]="model.FacetsOrder" />
                            </div>                                 
                            <div class="input-control">
                                <div class="title"><label for="SkipDisplayProperties">{{'USERSEARCHSETTING.SKIP_DISPLAY_PROPERTIES' | translate}}</label></div>
                                <input type="checkbox" name="SkipDisplayProperties" [(ngModel)]="model.SkipDisplayProperties" />
                            </div> 
                            <div class="input-control">
                                <div class="title"><label for="SkipSearchProperties">{{'USERSEARCHSETTING.SKIP_SEARCH_PROPERTIES' | translate}}</label></div>
                                <input type="checkbox" name="SkipSearchProperties" [(ngModel)]="model.SkipSearchProperties" />
                            </div> 

                            <div class="input-control">
                                <div class="title"><label for="UserId">{{'USERSEARCHSETTING.USER' | translate}}</label></div>
                                <input class="form-control" type="number" name="UserId" [(ngModel)]="model.UserId" />
                            </div>    
                            <div class="input-control">
                                <div class="title"><label for="UserGroupId">{{'USERSEARCHSETTING.USER_GROUP' | translate}}</label></div>
                                <input class="form-control" type="number" name="UserGroupId" [(ngModel)]="model.UserGroupId" />
                            </div>                                                            
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
                              </div>
                          </div>
                      </div>
                  </div> 

                  <div class="basic-info" *ngIf="activetab == 'properties'">
                        <div class="row">
                            <div>
                                <div class="input-control">
                                    <div class="title"><label for="PropertyPath">{{'USERSEARCHSETTING.PROPERTY_PATH' | translate}}</label></div>
                                    <input class="form-control" type="text" name="PropertyPath" [(ngModel)]="currentProperty.PropertyPath" />
                                </div> 
                                <div class="input-control">
                                    <div class="title"><label for="currentProperty_FieldType">{{'USERSEARCHSETTING.FIELD_TYPE' | translate}}</label></div>
                                    <select name="currentProperty_FieldType" [(ngModel)]="currentProperty.FieldType">
                                        <option value="1">{{'USERSEARCHSETTING.FIELD_TYPE_1' | translate}}</option>
                                        <option value="2">{{'USERSEARCHSETTING.FIELD_TYPE_2' | translate}}</option>
                                        <option value="4">{{'USERSEARCHSETTING.FIELD_TYPE_4' | translate}}</option>
                                    </select>
                                </div>                     
                                <div class="input-control">
                                    <div class="title"><label for="Order">{{'USERSEARCHSETTING.ORDER' | translate}}</label></div>
                                    <input class="form-control" type="number" name="Order" [(ngModel)]="currentProperty.Order" />
                                </div>   
                                <a class="btn btn-primary" (click)="addProperty()">{{'GLOBAL.BTN_ADD' | translate}}</a>                                           
                            </div>
                        </div>

                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>{{'USERSEARCHSETTING.PROPERTY_PATH' | translate}}</th>
                                    <th>{{'USERSEARCHSETTING.FIELD_TYPE' | translate}}</th>
                                    <th>{{'USERSEARCHSETTING.ORDER' | translate}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let prop of model.SearchFields; index as i">
                                    <td>{{prop.PropertyPath}}</td>
                                    <td>{{prop.FieldType}}</td>
                                    <td>{{prop.Order}}</td>
                                    <td><a class="text-danger" (click)="deleteProperty(i)">{{'GLOBAL.DELETE' | translate}}</a></td>
                                </tr>
                            </tbody>
                        </table>
                  </div>


              </div>
          </div>
  
      </div>
  </form>
  </div>